import { inject, Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { authConfig } from '../../../config/auth.config';
import { from, Observable } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  oAuthService = inject(OAuthService);
  storageService = inject(StorageService);

  initAuthObs(): Observable<boolean> {
    this.oAuthService.configure(authConfig);
    this.oAuthService.tokenValidationHandler = new JwksValidationHandler();
    this.oAuthService.setupAutomaticSilentRefresh();
    return from(this.oAuthService.loadDiscoveryDocumentAndTryLogin());
  }
}
